/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Rocket.net API
 * Rocket.net - All APIs
 * OpenAPI spec version: 1.0.0
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import { customFetch } from '../../custom-fetch';
import { addMetaToQuery } from '../../mutators/add-meta';
import type {
  BandwidthUsageReportingResponseObj,
  BandwidthUsageResponse,
  Error,
  ReportOnAccountBandwidthParams,
  ReportOnSiteBandwidthParams,
  ReportOnSiteBandwidthUsageParams,
  SiteID,
} from '../rocketNetAPI.schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Returns daily bandwidth consumption across your account over an optional date range, plus the period total.
 * @summary Get account bandwidth usage
 */
export const reportOnAccountBandwidth = (
  params?: ReportOnAccountBandwidthParams,
  signal?: AbortSignal
) => {
  return customFetch<BandwidthUsageResponse>({
    url: `/v1/account/bandwidth`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnAccountBandwidthQueryKey = (params?: ReportOnAccountBandwidthParams) => {
  return [`/v1/account/bandwidth`, ...(params ? [params] : [])] as const;
};

export const getReportOnAccountBandwidthQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnAccountBandwidth>>,
  TError = Error,
>(
  params?: ReportOnAccountBandwidthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnAccountBandwidth>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnAccountBandwidthQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnAccountBandwidth>>> = ({
    signal,
  }) => reportOnAccountBandwidth(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/account/bandwidth`,
      operationId: 'app.controllers.bandwidth_controller.report_on_account_bandwidth',
      operationName: 'reportOnAccountBandwidth',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnAccountBandwidth>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnAccountBandwidthQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnAccountBandwidth>>
>;
export type ReportOnAccountBandwidthQueryError = Error;

export function useReportOnAccountBandwidth<
  TData = Awaited<ReturnType<typeof reportOnAccountBandwidth>>,
  TError = Error,
>(
  params: undefined | ReportOnAccountBandwidthParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnAccountBandwidth>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnAccountBandwidth>>,
          TError,
          Awaited<ReturnType<typeof reportOnAccountBandwidth>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnAccountBandwidth<
  TData = Awaited<ReturnType<typeof reportOnAccountBandwidth>>,
  TError = Error,
>(
  params?: ReportOnAccountBandwidthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnAccountBandwidth>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnAccountBandwidth>>,
          TError,
          Awaited<ReturnType<typeof reportOnAccountBandwidth>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnAccountBandwidth<
  TData = Awaited<ReturnType<typeof reportOnAccountBandwidth>>,
  TError = Error,
>(
  params?: ReportOnAccountBandwidthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnAccountBandwidth>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get account bandwidth usage
 */

export function useReportOnAccountBandwidth<
  TData = Awaited<ReturnType<typeof reportOnAccountBandwidth>>,
  TError = Error,
>(
  params?: ReportOnAccountBandwidthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnAccountBandwidth>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnAccountBandwidthQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnAccountBandwidthSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnAccountBandwidth>>,
  TError = Error,
>(
  params?: ReportOnAccountBandwidthParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnAccountBandwidth>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnAccountBandwidthQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnAccountBandwidth>>> = ({
    signal,
  }) => reportOnAccountBandwidth(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/account/bandwidth`,
      operationId: 'app.controllers.bandwidth_controller.report_on_account_bandwidth',
      operationName: 'reportOnAccountBandwidth',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnAccountBandwidth>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnAccountBandwidthSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnAccountBandwidth>>
>;
export type ReportOnAccountBandwidthSuspenseQueryError = Error;

export function useReportOnAccountBandwidthSuspense<
  TData = Awaited<ReturnType<typeof reportOnAccountBandwidth>>,
  TError = Error,
>(
  params: undefined | ReportOnAccountBandwidthParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnAccountBandwidth>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnAccountBandwidthSuspense<
  TData = Awaited<ReturnType<typeof reportOnAccountBandwidth>>,
  TError = Error,
>(
  params?: ReportOnAccountBandwidthParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnAccountBandwidth>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnAccountBandwidthSuspense<
  TData = Awaited<ReturnType<typeof reportOnAccountBandwidth>>,
  TError = Error,
>(
  params?: ReportOnAccountBandwidthParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnAccountBandwidth>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get account bandwidth usage
 */

export function useReportOnAccountBandwidthSuspense<
  TData = Awaited<ReturnType<typeof reportOnAccountBandwidth>>,
  TError = Error,
>(
  params?: ReportOnAccountBandwidthParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnAccountBandwidth>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnAccountBandwidthSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns daily bandwidth consumption for one site over an optional date range, plus the period total.
 * @summary Get site bandwidth usage
 */
export const reportOnSiteBandwidth = (
  id: SiteID,
  params?: ReportOnSiteBandwidthParams,
  signal?: AbortSignal
) => {
  return customFetch<BandwidthUsageResponse>({
    url: `/v1/sites/${id}/reporting/bandwidth`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnSiteBandwidthQueryKey = (
  id?: SiteID,
  params?: ReportOnSiteBandwidthParams
) => {
  return [`/v1/sites/${id}/reporting/bandwidth`, ...(params ? [params] : [])] as const;
};

export const getReportOnSiteBandwidthQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidth>>,
  TError = Error,
>(
  id: SiteID,
  params?: ReportOnSiteBandwidthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidth>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteBandwidthQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteBandwidth>>> = ({ signal }) =>
    reportOnSiteBandwidth(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/reporting/bandwidth`,
      operationId: 'app.controllers.bandwidth_controller.report_on_site_bandwidth',
      operationName: 'reportOnSiteBandwidth',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteBandwidth>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteBandwidthQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteBandwidth>>
>;
export type ReportOnSiteBandwidthQueryError = Error;

export function useReportOnSiteBandwidth<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidth>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ReportOnSiteBandwidthParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidth>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteBandwidth>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteBandwidth>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteBandwidth<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidth>>,
  TError = Error,
>(
  id: SiteID,
  params?: ReportOnSiteBandwidthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidth>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteBandwidth>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteBandwidth>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteBandwidth<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidth>>,
  TError = Error,
>(
  id: SiteID,
  params?: ReportOnSiteBandwidthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidth>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get site bandwidth usage
 */

export function useReportOnSiteBandwidth<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidth>>,
  TError = Error,
>(
  id: SiteID,
  params?: ReportOnSiteBandwidthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidth>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteBandwidthQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnSiteBandwidthSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidth>>,
  TError = Error,
>(
  id: SiteID,
  params?: ReportOnSiteBandwidthParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidth>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteBandwidthQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteBandwidth>>> = ({ signal }) =>
    reportOnSiteBandwidth(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/reporting/bandwidth`,
      operationId: 'app.controllers.bandwidth_controller.report_on_site_bandwidth',
      operationName: 'reportOnSiteBandwidth',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteBandwidth>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteBandwidthSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteBandwidth>>
>;
export type ReportOnSiteBandwidthSuspenseQueryError = Error;

export function useReportOnSiteBandwidthSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidth>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ReportOnSiteBandwidthParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidth>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteBandwidthSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidth>>,
  TError = Error,
>(
  id: SiteID,
  params?: ReportOnSiteBandwidthParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidth>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteBandwidthSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidth>>,
  TError = Error,
>(
  id: SiteID,
  params?: ReportOnSiteBandwidthParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidth>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get site bandwidth usage
 */

export function useReportOnSiteBandwidthSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidth>>,
  TError = Error,
>(
  id: SiteID,
  params?: ReportOnSiteBandwidthParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidth>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteBandwidthSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns requests, bandwidth, and visitors for a site over a time window, with totals.
 * @summary Get site traffic overview
 */
export const reportOnSiteBandwidthUsage = (
  id: SiteID,
  params: ReportOnSiteBandwidthUsageParams,
  signal?: AbortSignal
) => {
  return customFetch<BandwidthUsageReportingResponseObj>({
    url: `/v1/sites/${id}/reporting/bandwidth/usage`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportOnSiteBandwidthUsageQueryKey = (
  id?: SiteID,
  params?: ReportOnSiteBandwidthUsageParams
) => {
  return [`/v1/sites/${id}/reporting/bandwidth/usage`, ...(params ? [params] : [])] as const;
};

export const getReportOnSiteBandwidthUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteBandwidthUsageQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>> = ({
    signal,
  }) => reportOnSiteBandwidthUsage(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/reporting/bandwidth/usage`,
      operationId: 'app.controllers.reporting_controller.report_on_site_bandwidth_usage',
      operationName: 'reportOnSiteBandwidthUsage',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteBandwidthUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>
>;
export type ReportOnSiteBandwidthUsageQueryError = Error;

export function useReportOnSiteBandwidthUsage<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthUsageParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteBandwidthUsage<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>,
          TError,
          Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteBandwidthUsage<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get site traffic overview
 */

export function useReportOnSiteBandwidthUsage<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteBandwidthUsageQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReportOnSiteBandwidthUsageSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthUsageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReportOnSiteBandwidthUsageQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>> = ({
    signal,
  }) => reportOnSiteBandwidthUsage(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/reporting/bandwidth/usage`,
      operationId: 'app.controllers.reporting_controller.report_on_site_bandwidth_usage',
      operationName: 'reportOnSiteBandwidthUsage',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportOnSiteBandwidthUsageSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>
>;
export type ReportOnSiteBandwidthUsageSuspenseQueryError = Error;

export function useReportOnSiteBandwidthUsageSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthUsageParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteBandwidthUsageSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthUsageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReportOnSiteBandwidthUsageSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthUsageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get site traffic overview
 */

export function useReportOnSiteBandwidthUsageSuspense<
  TData = Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: ReportOnSiteBandwidthUsageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof reportOnSiteBandwidthUsage>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getReportOnSiteBandwidthUsageSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
